import type { FinancialPropertyListItem } from "@/features/financialShared";
import {
	ServicePeriodStatus,
	UnitPayoutStatus,
} from "@/features/financialShared";
import {
	ChargesCategory,
	type ChargesUnitDetail,
	type ChargesUnitListItem,
} from "./chargesManagement.types";

export const CHARGES_PROPERTIES: FinancialPropertyListItem[] = [
	{
		id: "prop-oo-mandarina",
		name: "One&Only Mandarina",
		totalUnits: 48,
		latestServicePeriodLabel: "Jan 15, 2026 – Mar 15, 2026",
		chargesCategory: ChargesCategory.COMMON_AREA,
		status: ServicePeriodStatus.PUBLISHED,
		lastUpdatedDate: "Feb 15, 2026",
		approver: "Sarah Johnson",
	},
	{
		id: "prop-siro-boka",
		name: "SIRO Boka Place",
		totalUnits: 32,
		latestServicePeriodLabel: "Oct 1, 2025 – Dec 31, 2025",
		chargesCategory: ChargesCategory.UTILITIES,
		status: ServicePeriodStatus.COMPLETED,
		lastUpdatedDate: "Feb 12, 2026",
		approver: "Michael Chen",
	},
	{
		id: "prop-atlantis",
		name: "Atlantis The Royal",
		totalUnits: 52,
		latestServicePeriodLabel: "Jan 1, 2026 – Mar 31, 2026",
		chargesCategory: ChargesCategory.MANDATORY,
		status: ServicePeriodStatus.DRAFT,
		lastUpdatedDate: "Feb 8, 2026",
		approver: "Sarah Johnson",
	},
	{
		id: "prop-jumeirah",
		name: "Jumeirah Al Naseem",
		totalUnits: 36,
		latestServicePeriodLabel: "Apr 1, 2026 – Jun 30, 2026",
		chargesCategory: ChargesCategory.COMMON_AREA,
		status: ServicePeriodStatus.PUBLISHED,
		lastUpdatedDate: "Feb 3, 2026",
		approver: "Ayush Mehta",
	},
];

const CHARGES_UNITS: ChargesUnitListItem[] = [
	{
		id: "unit-v101",
		unitCode: "V-101",
		ownerName: "Olivia Martinez",
		ownerEmail: "olivia.martinez@example.com",
		amount: 1050,
		partialPayment: null,
		remainingLabel: "Fully Paid",
		isFullyPaid: true,
		paymentMethod: "App",
		status: UnitPayoutStatus.SETTLED,
	},
	{
		id: "unit-v102",
		unitCode: "V-102",
		ownerName: "James Wilson",
		ownerEmail: "james.wilson@example.com",
		amount: 1575,
		partialPayment: 500,
		remainingLabel: "AED 1,075",
		isFullyPaid: false,
		paymentMethod: "Bank Transfer",
		status: UnitPayoutStatus.PARTIALLY_PAID,
	},
	{
		id: "unit-v103",
		unitCode: "V-103",
		ownerName: "Aisha Khan",
		ownerEmail: "aisha.khan@example.com",
		amount: 2100,
		partialPayment: null,
		remainingLabel: "AED 2,100",
		isFullyPaid: false,
		paymentMethod: "Cheque",
		status: UnitPayoutStatus.PAST_DUE,
	},
	{
		id: "unit-v104",
		unitCode: "V-104",
		ownerName: "Mr Zahir Moossa",
		ownerEmail: "zahir.moossa@example.com",
		amount: 1575,
		partialPayment: null,
		remainingLabel: "Fully Paid",
		isFullyPaid: true,
		paymentMethod: "Bank Transfer",
		status: UnitPayoutStatus.SETTLED,
	},
];

const CHARGES_UNIT_DETAILS: Record<string, ChargesUnitDetail> = {
	"unit-v101": {
		id: "unit-v101",
		propertyId: "prop-oo-mandarina",
		periodId: "period-jan-mar-26",
		invoiceNumber: "INV-1001",
		unitCode: "V-101",
		ownerName: "Olivia Martinez",
		ownerInitials: "OM",
		ownerPhone: "+971 55 987 6543",
		ownerEmail: "olivia.martinez@example.com",
		unitDetail: "One&Only Mandarina · V-101",
		status: UnitPayoutStatus.SETTLED,
		servicePeriodLabel: "Jan 15, 2026 – Mar 15, 2026",
		invoiceDate: "Feb 10, 2026",
		paymentDate: "Feb 5, 2026",
		totalAmount: 1575,
		lineItems: [
			{
				category: "Common Area Charges",
				description: "Utilities & Insurance",
				amount: 500,
				tax: 25,
				total: 525,
			},
			{
				category: "Common Area Charges",
				description: "Administrative Charges",
				amount: 500,
				tax: 25,
				total: 525,
			},
			{
				category: "Mandatory Services",
				description: "Administrative Costs",
				amount: 500,
				tax: 25,
				total: 525,
			},
		],
	},
};

export function getChargesProperties(): FinancialPropertyListItem[] {
	return [...CHARGES_PROPERTIES];
}

export function getChargesPropertyById(
	id: string,
): FinancialPropertyListItem | undefined {
	return CHARGES_PROPERTIES.find((property) => property.id === id);
}

export function getChargesUnitsByPeriod(
	_periodId: string,
): ChargesUnitListItem[] {
	return [...CHARGES_UNITS];
}

export function getChargesUnitDetail(
	unitId: string,
): ChargesUnitDetail | undefined {
	return CHARGES_UNIT_DETAILS[unitId];
}

export function getChargesPropertyOptionsForModal(): {
	value: string;
	label: string;
}[] {
	return CHARGES_PROPERTIES.map((property) => ({
		value: property.id,
		label: property.name,
	}));
}
